import React, { useState, useEffect } from "react";
import MultiBets from "../component/MultiBets";
import BestBet from "../component/Bestbet";
import Treblewin from "../component/Treblewin";
import { fetchJoinUserApi, fetchMultibetleaguesDataApi, fetchSubscriptionCheckIpApi } from "../api/api";
import SignupPopup from "../component/SignupPopup"


function Firstpage({oddsFormat, language, setToken, token}) {
  const [clickCount, setClickCount] = useState(0);
  const [leagueData, setLeagueData] = useState([]);
  // const [blockPopup, setBlockPopup] = useState(false);
  const [showPopupSignup, setShowPopupSignup] = useState(false);


  const subscriptionStatus = sessionStorage.getItem("subscriptionStatus");

  const handleClose = () => {
  setShowPopupSignup(false);
  setClickCount(11);
};


  // useEffect(() => {
  //   const fetchIP = async () => {
  //     try {
  //       const res = await fetch("https://api.ipify.org?format=json");
  //       const data = await res.json();
  //       // setIP(data.ip);

  //       // 🔹 Check if IP exists in backend
  //       if (data.ip) {
  //         try {
  //           const res = await fetchSubscriptionCheckIpApi(data.ip);

  //           if (res?.statuscode === 200) {
  //             // setBlockPopup(true);
  //           }
  //         } catch (err) {
  //           console.error("Error checking IP:", err);
  //         }
  //       }
  //     } catch (err) {
  //       console.error("Error fetching IP:", err);
  //     }
  //   };

  //   fetchIP();
  // }, []);

const handlePageClick = () => {
  if (!token) {
    setClickCount((prev) => {
      const updated = prev + 1;

      if (updated === 10) {
        setShowPopupSignup(true);
        return 10;
      }

      if (updated > 12) {
        setShowPopupSignup(true);
        return 12;
      }

      return updated;
    });
  }
};
  useEffect(() => {
    if (showPopupSignup) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "auto";
    }
  }, [showPopupSignup]);

  

  useEffect(() => {
    const fetchLeagueData = async () => {
      try {
        const leagueData = await fetchMultibetleaguesDataApi(language);
        const data = leagueData.data;
        setLeagueData(data);
      } catch (error) {
        console.error("Error fetching league data:", error);
      }
    };
    fetchLeagueData();
  }, [language]);

useEffect(() => {
  const handleActions = (e) => {
    // Check if target is an element
    const target = e.target;
    if (!(target instanceof Element) || !target.closest('.modal-content-forgot')) {
      e.preventDefault();
    }
  };

  document.addEventListener("copy", handleActions);
  document.addEventListener("paste", handleActions);
  document.addEventListener("cut", handleActions);
  document.addEventListener("selectstart", handleActions);

  return () => {
    document.removeEventListener("copy", handleActions);
    document.removeEventListener("paste", handleActions);
    document.removeEventListener("cut", handleActions);
    document.removeEventListener("selectstart", handleActions);
  };
}, []);




  return (
    <div className="BL-affiliates" onClick={handlePageClick}>

      <div className="AF-container">
        <div className="AF-pageContent">

          <div className="grid-top">
            {/* Left Side */}
            <div className="col-8_lg-8_md-12_sm-12_xs-12">
              <div className="grid-noGutter space-1">
                <div className="space-5"></div>
              </div>
              <div id="component-best">
                <BestBet
                  oddsFormat={oddsFormat} 
                  language={language}
                  subscriptionStatus={subscriptionStatus}
                  showPopupSignup={showPopupSignup}
                />
              </div>
              <div className="grid-noGutter-middle">
                <div className="space-10"></div>
              </div>

              <div id="component-treble">
                <Treblewin
                  oddsFormat={oddsFormat}
                  leagueData={leagueData}
                  language={language}
                  subscriptionStatus={subscriptionStatus}
                  showPopupSignup={showPopupSignup}
                />
              </div>

              <div className="grid-noGutter-middle">
                <div className="space-10"></div>
              </div>
            </div>

            <div className="col-4_lg-4_md-12_sm-12_xs-12">
              <div className="AF-righSideBar">
                <div id="component-multi">
                  <MultiBets
                    oddsFormat={oddsFormat}
                    leagueData={leagueData}
                    language={language}
                    subscriptionStatus={subscriptionStatus}
                  />
                </div>

                <div className="grid-noGutter">
                  <div className="space-10"></div>
                </div>

              </div>
            </div>
          </div>
        </div>
      </div>

      
    {showPopupSignup && (
        <SignupPopup
          showPopup={showPopupSignup} 
          handleClose={handleClose}
          setToken={setToken}
          hederLogin={false}
        />
      )}
      
    </div>
  );
}

export default Firstpage;
